import React from 'react'

const EquipmentAndTerminals = () => {
  return (
    <div>EquipmentAndTerminals</div>
  )
}

export default EquipmentAndTerminals